<template>
  <div class="addroster">
    <div class="newsDetial-header">
      <div class="newsDetial-title">{{ title }}</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract" v-if="!id">
        请按照表单要求添加和修改数据
      </div>
      <blank height="45"> </blank>
    </div>
    <!-- 基本信息 -->
    <div class="detial-cont">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">姓名 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.fullName"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">所在部门 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.departmentName"
            />
            <!-- <a-tree-select
              v-model="Form.organizationId"
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择部门"
              tree-default-expand-all
              :replaceFields="replaceFields"
            >
            </a-tree-select> -->
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">身份证号 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.idCardNumber"
              @blur="idCardNumberBlur"
            />
          </a-descriptions-item>
          <a-descriptions-item label="出生年月" v-if="id">
            <a-date-picker
              class="w300"
              :valueFormat="dayFormat"
              v-model="Form.birthTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="民族">
            <a-input class="w300" placeholder="请添加" v-model="Form.nation" />
          </a-descriptions-item>
          <a-descriptions-item label="籍贯">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.nativePlace"
            />
          </a-descriptions-item>
          <a-descriptions-item label="政治面貌">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.politicalType"
            >
              <a-select-option
                v-for="item in politicalTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item
            label="入党时间"
            v-if="Form.politicalType == 1500"
          >
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.joinPartyTime"
            />
          </a-descriptions-item>

          <a-descriptions-item label="健康状况">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.healthStatus"
            >
              <a-select-option
                v-for="item in healthStatusList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="技术职称">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.technicalTitle"
            />
          </a-descriptions-item>
          <a-descriptions-item label="军转干部/复原军人">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.militaryCadres"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >参加工作时间 <span class="required">*</span></span
            >
            <!-- dayFormat monthFormat -->
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.firstWorkTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="总工龄" v-if="id">
            <!-- <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.totalSystemAge"
            /> -->
            <a-input-number
              v-model="totalSystemAgeYears"
              :min="0"
              :max="99"
              class="mr10"
              @blur="blur('1')"
            />年
            <a-input-number
              v-model="totalSystemAgeMonth"
              :min="0"
              :max="12"
              class="ml10"
              @blur="blur('2')"
            />月
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >进入民政系统时间 <span class="required">*</span></span
            >
            <a-month-picker
              :valueFormat="monthFormat"
              class="w300"
              v-model="Form.civilOfficeSysTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="户口所在地">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.registeredResidence"
            />
          </a-descriptions-item>

          <a-descriptions-item label="家庭地址">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.homeAddress"
            />
          </a-descriptions-item>
          <!-- <a-descriptions-item label="县区">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.homeAddress"
            />
          </a-descriptions-item> -->
          <a-descriptions-item label="联系方式"
            ><a-input class="w300" placeholder="请添加" v-model="Form.phone" />
          </a-descriptions-item>
          <a-descriptions-item label="区县"
            ><a-input class="w300" placeholder="请添加" v-model="Form.county" />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <!-- 学历信息 -->
    <div class="detial-cont">
      <div class="detial-cont-title">学历信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="全日制教育学历">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.firstEducation"
            >
              <a-select-option
                v-for="item in educationList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="全日制教育学位">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstAcademicDegree"
            />
          </a-descriptions-item>
          <a-descriptions-item label="全日制教育专业">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstMajor"
            />
          </a-descriptions-item>

          <a-descriptions-item label="全日制教育毕业院校">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.firstGraduationSchool"
            />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育学历">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.education"
            >
              <a-select-option
                v-for="item in educationList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="在职教育学位">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.academicDegree"
            />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育专业">
            <a-input class="w300" placeholder="请添加" v-model="Form.major" />
          </a-descriptions-item>
          <a-descriptions-item label="在职教育毕业院校">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.graduationSchool"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <!-- 退休信息 -->
    <div class="detial-cont">
      <div class="detial-cont-title">退休信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >退休前职务
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.retirePosition"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >退休时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.retireTime"
            />
          </a-descriptions-item>
          <a-descriptions-item label="退休身份">
            <a-select
              class="w300"
              placeholder="请选择"
              v-model="Form.retireIdentity"
            >
              <a-select-option
                v-for="item in retireIdentityList"
                :value="item.keyname"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="退休类别">
            <a-select
              class="w300"
              placeholder="请选择"
              v-model="Form.retireType"
            >
              <a-select-option
                v-for="item in retireTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <!-- <a-descriptions-item>
            <span slot="label">退休备注</span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.description"
            />
          </a-descriptions-item> -->
        </a-descriptions>
      </div>
    </div>
    <!-- 死亡信息 -->
    <div class="detial-cont">
      <div class="detial-cont-title">死亡信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >死亡时间
              <!-- <span class="required">*</span> -->
            </span>
            <a-date-picker
              :valueFormat="dayFormat"
              class="w300"
              v-model="Form.deathTime"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >死亡档案号
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.deathNumber"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >办理人员姓名
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.handleName"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >办理人员手机号
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.handlePhone"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >办理人员身份证号
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.handleCardNo"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >备注
              <!-- <span class="required">*</span> -->
            </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.description"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <!-- 死亡档案 -->
    <div class="detial-cont">
      <div class="detial-cont-title">死亡档案</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- :updateList="temp" -->
        <deathRecords
          @deathPersonnelManagerFileList="deathPersonnelManagerFileList"
        ></deathRecords>
      </div>
    </div>
    <!-- 遗属待遇办理进度 -->
    <div class="detial-cont">
      <div class="detial-cont-title">遗属待遇办理进度</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div>
          <a-table
            :pagination="false"
            :columns="columnsDeathWillHandleListData"
            :data-source="Form.deathWillHandleList"
            :row-key="record => record.index"
          >
            <div slot="number" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
            <!-- 办理时间 -->
            <div slot="handleTime" slot-scope="text, record">
              <a-date-picker
                :valueFormat="dayFormat"
                class="w200"
                v-model="record.handleTime"
              />
            </div>
            <!-- 遗嘱办理事项 -->
            <div slot="handleMatter" slot-scope="text, record">
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="record.handleMatter"
              />
            </div>
            <!-- 办理人 -->
            <div slot="handleName" slot-scope="text, record">
              <a-input
                allowClear
                class="w100"
                placeholder="请输入"
                v-model="record.handleName"
              />
            </div>
            <!-- 备注 -->
            <div slot="description" slot-scope="text, record">
              <a-input
                allowClear
                class="w200"
                placeholder="请输入"
                v-model="record.description"
              />
            </div>
            <!-- <div slot="action" slot-scope="text, record"></div> -->
          </a-table>
          <div class="accessory-btn">
            <a-button @click="addDeathWillRow()"
              ><a-icon type="plus" />添加
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 开具材料情况 -->
    <div class="detial-cont">
      <div class="detial-cont-title">开具材料情况</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <materialsTable
          v-model="Form.deathMaterialScienceList"
          :file="Form.deathMaterialScienceList"
          :id="materialId"
        ></materialsTable>
      </div>
    </div>
    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goback">
        返回
      </a-button>
      <!-- <a-button
        v-if="id"
        type="primary"
        :style="{ marginRight: '20px' }"
        @click="setpop()"
      >
        减员
      </a-button> -->
      <a-button
        type="primary"
        :loading="confirmLoading"
        :style="{ marginRight: '42px' }"
        @click="subMit"
      >
        提交
      </a-button>
    </bottomSuspension>
    <a-modal
      v-model="ispop"
      title="减员操作"
      @ok="handleOk"
      :confirm-loading="depLoading"
    >
      <prompts> 请选择减员原因，并填写减员备注信息</prompts>
      <div class="dep-form">
        <div class="dep-form-item">
          <div class="dep-form-lable">减员原因：</div>
          <a-radio-group v-model="delData.positionStatus">
            <template v-for="item in positionStatusList">
              <a-radio
                :value="item.valuename"
                :key="item.id"
                v-if="item.valuename !== '1001'"
              >
                {{ item.keyname }}
              </a-radio>
            </template>
          </a-radio-group>
        </div>
        <blank height="25"> </blank>
        <div class="dep-form-item">
          <div class="dep-form-lable">减员备注：</div>
        </div>
        <div class="dep-form-item">
          <a-input
            v-model="delData.cause"
            type="textarea"
            class="w500"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// 遗嘱办理进度列表-列
const columnsDeathWillHandleListData = [
  {
    key: "number",
    scopedSlots: { customRender: "number" },
    title: "序号",
    align: "left",
    width: 120
  },
  {
    key: "handleTime",
    scopedSlots: { customRender: "handleTime" },
    title: "办理时间",
    align: "left"
    // width: 100
  },
  {
    key: "handleMatter",
    scopedSlots: { customRender: "handleMatter" },
    title: "遗属待遇办理事项",
    align: "left"
    // width: 100,
  },

  {
    key: "handleName",
    scopedSlots: { customRender: "handleName" },
    title: "办理人",
    align: "left"
    // width: 100,
  },
  {
    key: "description",
    scopedSlots: { customRender: "description" },
    title: "备注",
    align: "left"
    // width: 100,
  }
];
import {
  personnelGet,
  deathPersonnelManagerPersonnelGet,
  savePersonnelManager,
  saveDeathPersonnelManager,
  updatePersonnelManager,
  updateDeathPersonnelManager,
  getTreeList,
  updatePositionStatus
} from "../api/api";
import { mapState, mapActions } from "vuex";
import { validateIdCard } from "@/assets/js/auth.js";
// import testamentTable from './components/testament-table.vue'
import materialsTable from "./components/materials-table.vue";
import deathRecords from "./components/death-records.vue";
export default {
  components: {
    // testamentTable,
    materialsTable,
    deathRecords
  },
  data() {
    return {
      confirmLoading: false,
      title: "新建花名册信息",
      treeData: [], // 组织机构树
      replaceFields: {
        key: "id",
        value: "id",
        children: "treeList",
        title: "organizationName"
      },
      dayFormat: "YYYY.MM.DD",
      monthFormat: "YYYY.MM",
      Form: {
        deathPersonnelManagerFileList: [], //死亡档案附件
        deathWillHandleList: [], //遗嘱办理进度表格数据
        deathMaterialScienceList: [] // 开具材料表格数据
      },
      retireIdentityList: [
        { id: 1, valuename: "001", keyname: "工人" },
        { id: 2, valuename: "002", keyname: "干部" }
      ], // 退休身份
      totalSystemAgeYears: "", //年
      totalSystemAgeMonth: "", //月
      id: "",
      delData: {}, // 减员操作信息
      ispop: false, // 减员弹窗
      depLoading: false,
      // temp: [{ filename: 'name', fileformat: 'for' }]
      columnsDeathWillHandleListData, // 遗嘱办理进度列表-列
      materialId: ""
    };
  },
  created() {
    this.getByType();
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.id) {
      this.$route.meta.title = this.title = "修改花名册个人信息";
      deathPersonnelManagerPersonnelGet(this.id).then(res => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
          if (this.Form.totalSystemAge) {
            // 总工龄存在
            let yearIndex = this.Form.totalSystemAge.indexOf("年");
            let monthIndex = this.Form.totalSystemAge.indexOf("月");
            this.totalSystemAgeYears = this.Form.totalSystemAge.substring(
              0,
              yearIndex
            );
            this.totalSystemAgeMonth = this.Form.totalSystemAge.substring(
              yearIndex + 1,
              monthIndex
            );
          }
        }
      });
    }
  },
  computed: {
    ...mapState({
      positionList: state => state.bytype.positionList, //行政职务
      positionLevelList: state => state.bytype.positionLevelList, //职级
      politicalTypeList: state => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: state => state.bytype.contractTypeList, //劳动合同类型
      educationList: state => state.bytype.educationList, //学历
      registeredNatureList: state => state.bytype.registeredNatureList, //户口性质
      healthStatusList: state => state.bytype.healthStatusList, //健康状态
      positionStatusList: state => state.bytype.positionStatusList, //减员原因
      retireTypeList: state => state.bytype.retireTypeList // 退休类别
    })
  },
  methods: {
    ...mapActions([
      "getposition",
      "getpositionLevel",
      "getpoliticalType",
      "getcontractType",
      "geteducation",
      "getregisteredNature",
      "gethealthStatus",
      "getpositionStatus",
      "getRetireTypeList"
    ]),
    blur(type) {
      if (type == 1) {
        this.totalSystemAgeYears = parseInt(this.totalSystemAgeYears);
      }
      if (type == 2) {
        this.totalSystemAgeMonth = parseInt(this.totalSystemAgeMonth);
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      getTreeList().then(res => {
        this.treeData = res.data.data;
      });
      //行政职务
      this.getposition();
      //职级
      this.getpositionLevel();
      //政治面貌
      this.getpoliticalType();
      //劳动合同类型
      this.getcontractType();
      //学历
      this.geteducation();
      //户口性质
      this.getregisteredNature();
      //健康状态
      this.gethealthStatus();
      //减员原因
      this.getpositionStatus();
      // 退休类别
      this.getRetireTypeList();
    },
    contractTypeChange(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "firstContractYears", "长期");
      } else {
        this.$set(this.Form, "firstContractYears", "");
      }
    },
    contractTypeChange1(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "secondContractYears", "长期");
      } else {
        this.$set(this.Form, "secondContractYears", "");
      }
    },
    contractTypeChange2(e) {
      //选择合同类型
      if (e == "1101") {
        //无固定期限
        this.$set(this.Form, "thirdContractYears", "长期");
      } else {
        this.$set(this.Form, "thirdContractYears", "");
      }
    },
    subMit() {
      // 点击提交
      if (!this.Form.fullName) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!this.Form.idCardNumber) {
        this.$message.error("请填写身份证号");
        return;
      }
      if (!this.Form.firstWorkTime) {
        this.$message.error("请选择首次参加工作时间");
        return;
      }
      if (!this.Form.civilOfficeSysTime) {
        this.$message.error("请选择进入民政系统时间");
        return;
      }
      this.confirmLoading = true;
      if (this.id) {
        // 修改
        this.Form.totalSystemAge =
          this.totalSystemAgeYears + "年" + this.totalSystemAgeMonth + "月";
        updateDeathPersonnelManager(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.goback();
            this.confirmLoading = false;
          } else {
            this.confirmLoading = false;
          }
        });
      } else {
        //添加
        saveDeathPersonnelManager(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.goback();
            this.confirmLoading = false;
          } else {
            this.confirmLoading = false;
          }
        });
      }
    },
    goback() {
      this.$router.push("/TheDead");
    },
    idCardNumberBlur() {
      if (!this.Form.idCardNumber) return;
      let n = validateIdCard(this.Form.idCardNumber);
      if (!n) {
        this.Form.idCardNumber = "";
        this.$message.error("身份证号格式错误");
      }
    },
    setpop() {
      this.ispop = true;
    },
    handleOk(e) {
      // 确定减员
      this.depLoading = true;
      let params = this.delData;
      params.id = this.id;
      updatePositionStatus(params).then(res => {
        if (res.data.code == 0) {
          this.$message.success("减员操作成功");
          this.ispop = false;
          this.goback();
          this.depLoading = false;
        } else {
          this.depLoading = false;
        }
      });
    },
    // 接收死亡档案附件 并赋值给From
    deathPersonnelManagerFileList(data) {
      if (data) {
        this.Form.deathPersonnelManagerFileList = data;
      }
    },
    // 添加死亡遗嘱表格行
    addDeathWillRow() {
      this.Form.deathWillHandleList.push({});
    }
  }
};
</script>

<style lang="scss" scoped>
.addroster {
  .newsDetial-header {
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
    }
  }
}
.dep-form {
  width: 468px;
  margin-top: 40px;
  .dep-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .dep-form-lable {
      width: 70px;
      height: 21px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      line-height: 21px;
      text-align: left;
    }
  }
  .operating-checkbox-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
// 添加按钮
.accessory-btn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheDead/add.vue